// extracted by mini-css-extract-plugin
module.exports = {"cmtbtnwrapper":"U4a_b","innercomment_box":"i_TW7","aucmt":"Llmy5","name":"CDDJU","prime":"Ew1Sn","flagComment":"GzPZ7"};